module.exports = __webpack_public_path__ + "i18n/pt-BR.3e03733582ed95fa8433988477f830af.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/pt-BR.json
// module id = 1008
// module chunks = 60